import { render, staticRenderFns } from "./Pushnoti.vue?vue&type=template&id=2a8657b6&"
import script from "./Pushnoti.vue?vue&type=script&lang=js&"
export * from "./Pushnoti.vue?vue&type=script&lang=js&"
import style0 from "./Pushnoti.vue?vue&type=style&index=0&id=2a8657b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports